export enum ProfileMigrationStateEnum {
  IN_PROGRESS = "in_progress",
  COMPLETED = "completed",
  NOT_NEEDED = "not_needed",
}
